const isProd = process.env.NODE_ENV === 'production';

function formatMessage(scope, message) {
  if (!scope) return message;
  return `[${scope}] ${message}`;
}

export const logger = {
  log(scope, message, ...meta) {
    if (isProd) return;
    console.log(formatMessage(scope, message), ...meta);
  },
  warn(scope, message, ...meta) {
    if (isProd) return;
    console.warn(formatMessage(scope, message), ...meta);
  },
  error(scope, message, ...meta) {
    if (isProd) return;
    console.error(formatMessage(scope, message), ...meta);
  },
};
